var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle-container"},[_c('h2',{staticClass:"home-subtitle",style:(_vm.styles)},[_vm._t("text")],2),_vm._v(" "),_vm._t("side")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }